export interface ReviewFormData {
  rating: number;
  title: string;
  content: string;
  nickname: string;
  email: string;
  skinType: string;
  skinConcern: string;
  images: File[];
  recommend: string;
}

export interface BaseReviewModalProps {
  isOpen: boolean;
  productInfo: {
    name: string;
    brand: string;
    image: string;
    category: string;
  };
  onClose: () => void;
}

export interface ReviewModalProps extends BaseReviewModalProps {
  onSubmit: (values: ReviewFormData) => Promise<void>;
}

export interface SelectOption {
  value: string;
  label: string;
}

export interface ReviewFormActions {
  setRating: (v: number) => void;
  setTitle: (v: string) => void;
  setContent: (v: string) => void;
  setNickname: (v: string) => void;
  setEmail: (v: string) => void;
  setSkinType: (v: string) => void;
  setSkinConcern: (v: string) => void;
  setImages: (v: File[]) => void;
  setRecommend: (v: string) => void;
}

export interface ReviewFormOptions {
  skinTypeOptions: SelectOption[];
  skinConcernOptions: SelectOption[];
}

export interface ReviewFormProps {
  formData: ReviewFormData;
  formActions: ReviewFormActions;
  options: ReviewFormOptions;
  productInfo: {
    name: string;
    brand: string;
    image: string;
    category: string;
  };
  isSubmitDisabled: boolean;
  onSubmit: () => void;
}
